import { agentTestEvents } from '@shared/services/agent-test';
import { socket } from '../..';

export const handleAgentTestSwitchAgent = () => {
  return socket.onMessage('AGENT_TEST_SWITCH_AGENT', (payload) => {
    agentTestEvents.emitSwitchAgent(payload);
  });
};
